const OwnPropertiesData = [
  {
    project_name: "Nasa City Johar",
    img: "property/grid-two.jpg",
    bed: 4,
    bath: 2,
    btn: "Sell Now",
    btn_link: "/sell-prop-details",
  },
  {
    project_name: "Nasa City Johar",
    img: "property/grid-five.jpg",
    bed: 4,
    bath: 2,
    btn: "Sell Now",
    btn_link: "/sell-prop-details",
  },
  {
    project_name: "Nasa City Johar",
    img: "property/grid-three.jpg",
    bed: 4,
    bath: 2,
    btn: "Sell Now",
    btn_link: "/sell-prop-details",
  },
  {
    project_name: "Nasa City Johar",
    img: "property/grid-four.jpg",
    bed: 4,
    bath: 2,
    btn: "Sell Now",
    btn_link: "/sell-prop-details",
  },
  {
    project_name: "Nasa City Johar",
    img: "property/grid-one.jpg",
    bed: 4,
    bath: 2,
    btn: "Sell Now",
    btn_link: "/sell-prop-details",
  },

  {
    project_name: "Nasa City Johar",
    img: "property/grid-six.jpg",
    bed: 4,
    bath: 2,
    btn: "Sell Now",
    btn_link: "/sell-prop-details",
  },
  {
    project_name: "Nasa City Johar",
    img: "property/grid-two.jpg",
    bed: 4,
    bath: 2,
    btn: "Sell Now",
    btn_link: "/sell-prop-details",
  },
  {
    project_name: "Nasa City Johar",
    img: "property/grid-four.jpg",
    bed: 4,
    btn: "Sell Now",
    btn_link: "/sell-prop-details",

    bath: 2,
  },
  {
    project_name: "Nasa City Johar",
    img: "property/grid-five.jpg",
    bed: 4,
    bath: 2,
    btn: "Sell Now",
    btn_link: "/sell-prop-details",
  },
  {
    project_name: "Nasa City Johar",
    img: "property/grid-four.jpg",
    bed: 4,
    bath: 2,
    btn: "Sell Now",
    btn_link: "/sell-prop-details",
  },
  {
    project_name: "Nasa City Johar",
    img: "property/grid-two.jpg",
    bed: 4,
    bath: 2,
    btn: "Sell Now",
    btn_link: "/sell-prop-details",
  },
  {
    project_name: "Nasa City Johar",
    img: "property/grid-two.jpg",
    bed: 4,
    bath: 2,
    btn: "Sell Now",
    btn_link: "/sell-prop-details",
  },
  {
    project_name: "Nasa City Johar",
    img: "property/grid-two.jpg",
    bed: 4,
    bath: 2,
    btn: "Sell Now",
    btn_link: "/sell-prop-details",
  },
  {
    project_name: "Nasa City Johar",
    img: "property/grid-four.jpg",
    bed: 4,
    bath: 2,
    btn: "Sell Now",
    btn_link: "/sell-prop-details",
  },
  {
    project_name: "Nasa City Johar",
    img: "property/grid-five.jpg",
    bed: 4,
    bath: 2,
    btn: "Sell Now",
    btn_link: "/sell-prop-details",
  },
  {
    project_name: "Nasa City Johar",
    img: "property/grid-four.jpg",
    bed: 4,
    bath: 2,
    btn: "Sell Now",
    btn_link: "/sell-prop-details",
  },
  {
    project_name: "Nasa City Johar",
    img: "property/grid-five.jpg",
    bed: 4,
    bath: 2,
    btn: "Sell Now",
    btn_link: "/sell-prop-details",
  },
  {
    project_name: "Nasa City Johar",
    img: "property/grid-six.jpg",
    bed: 4,
    bath: 2,
    btn: "Sell Now",
    btn_link: "/sell-prop-details",
  },
];

export default OwnPropertiesData;
